<template>
  <div class="main text-left">
    <div class="form-group">
      <label class="text-muted small">ユーザーID <span class="text-danger">*必須</span></label>
      <input type="email" class="form-control form-control-sm" v-model="input.username" :maxlength="50" placeholder="メールアドレス">
    </div>
    <div class="form-group">
      <label class="text-muted small">パスワード <span class="text-danger">*必須</span></label>
      <input type="password" class="form-control form-control-sm" v-model="input.password" :maxlength="50" placeholder="パスワード">
    </div>
    <div class="form-group form-check" v-if="false">
      <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="this.$store.state.automanaged" v-on:click="onAutoCheck()">
      <label class="form-check-label text-muted small" for="exampleCheck1">自動アカウント管理</label>
    </div>
    <span class="btn btn-warning btn-sm" v-on:click="login()">ログイン</span>
    <small class="form-text text-muted">リベルタアカウントを取得する場合<span class="btn btn-sm btn-link" v-on:click="toRegister()">アカウントを作成</span></small>
    <small class="form-text text-muted">ログインできない場合<span class="btn btn-sm btn-link" v-on:click="toRecovery()">パスワード再発行</span></small>
  </div>
</template>
<script>
import sx from '../utils/core.js'

export default {
  data() {
    return {
      input: {
        username: '',
        password: ''
      }
    }
  },
  mounted () {
    this.$store.state.title = 'ログイン'
    this.input.username = localStorage.getItem('username')
    this.input.password = sx.decrypt(localStorage.getItem('password'), '')
    this.$store.state.authenticated = false
    localStorage.setItem('token', '')
    localStorage.setItem('authenticated', false)
    localStorage.setItem('userinfo', '')
  },
  methods: {
    onAutoCheck() {
      const that = this
      that.$store.state.automanaged = !that.$store.state.automanaged
    },
    toRegister() {
      this.$router.replace({ name: 'Register' })
    },
    toRecovery() {
      this.$router.replace({ name: 'Recovery' })
    },
    login() {
      const that = this
      if (!sx.isNothingOrEmpty(that.input.username) && !sx.isNothingOrEmpty(that.input.password)) {
        var params = {
          username: that.input.username,
          password: that.input.password,
          corpid: 40,
          bucketid: '17',
          token: ''
        }
        sx.request(
          that.$store.state.baseurl + '/app/account/login',
          params,
          function(result) {
            if (result.status === 'ok') {
              sx.toastSuccess('ログイン成功しました！')
              var d = result.data
              localStorage.setItem('token', d.token)
              localStorage.setItem('authenticated', true)
              localStorage.setItem('automanaged', that.$store.state.automanaged)
              localStorage.setItem('username', that.input.username)
              localStorage.setItem('password', sx.encrypt(that.input.password, ''))
              localStorage.setItem('userinfo', JSON.stringify(d.userinfo))
              that.$store.state.authenticated = true
              that.$store.state.userinfo = d.userinfo;
              that.$router.replace({ name: 'My' })
            } else if (result.status == 'err') {
              sx.toastError('パスワードが一致していません。<br>再度試してください！')
              console.log('wrong password!')
            } else {
              sx.toastError('アカウントが存在しません！')
              console.log('Account not exist!')
            }
          }
        )
        sx.hideWaiting()
      } else {
        if (sx.isNothingOrEmpty(that.input.username)) {
          sx.toastError('メールアドレスを入力してください！')
          return;
        }
        if (sx.isNothingOrEmpty(that.input.password)) {
          sx.toastError('パスワードを入力してください！')
          return;
        }
        console.log('required!')
      }
    }
  }
}
</script>
<style scoped>
.main {
  padding:20px;
}
</style>
